"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var wIsNode = true;

try {
  wIsNode = window === undefined;
} catch (e) {}

var _default = wIsNode;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pc05vZGUuanMiXSwibmFtZXMiOlsid0lzTm9kZSIsIndpbmRvdyIsInVuZGVmaW5lZCIsImUiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLElBQUlBLE9BQU8sR0FBRyxJQUFkOztBQUNBLElBQUk7QUFDSEEsRUFBQUEsT0FBTyxHQUFHQyxNQUFNLEtBQUtDLFNBQXJCO0FBQ0EsQ0FGRCxDQUVFLE9BQU9DLENBQVAsRUFBVSxDQUNYOztlQUVjSCxPIiwic291cmNlc0NvbnRlbnQiOlsibGV0IHdJc05vZGUgPSB0cnVlO1xyXG50cnkge1xyXG5cdHdJc05vZGUgPSB3aW5kb3cgPT09IHVuZGVmaW5lZDtcclxufSBjYXRjaCAoZSkge1xyXG59XHJcblxyXG5leHBvcnQgZGVmYXVsdCB3SXNOb2RlO1xyXG4iXX0=